"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatingFirstDayEditor = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Date_1 = require("../../../Form/Field/Date");
const RepeatingFirstDayEditor = (props) => {
    const { field, disabledBeforeDay } = props;
    const fieldProps = {
        autoComplete: 'off',
        name: 'firstDate',
        readOnly: true,
        showUpper: true,
        disabled: true,
        restrictions: { disabledBeforeDay },
        info: ([
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit/Repeating:FirstFlightHint', defaultMessage: 'Read only field. Please fill departure.', key: 0 }),
        ]),
        label: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Edit/Repeating:FirstFlight', defaultMessage: 'First flight' })),
        modificators: field.modifiers,
        error: field.error,
        value: field.value,
        setValue: field.onValue,
    };
    return (react_1.default.createElement(Date_1.FormFieldDate, { ...fieldProps }));
};
exports.RepeatingFirstDayEditor = RepeatingFirstDayEditor;
//# sourceMappingURL=RepeatingFirstDayEditor.js.map